import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

const ACTION_LABEL = {
  login: "Login",
  create: "Criação",
  create_manual: "Reserva manual",
  update: "Atualização",
  delete: "Exclusão",
  confirm: "Confirmação",
  cancel: "Cancelamento",
  manual_confirm: "Conferência manual",
  refund: "Estorno",
  payment_approved: "Pagamento aprovado",
  add_photo: "Foto adicionada",
  mfa_enable: "MFA ativado",
  mfa_disable: "MFA desativado",
  password_change: "Troca de senha",
  expire_hold: "Hold expirado",
  check_in_reminder: "Lembrete de check-in",
  cron_run: "Execução programada",
};

const ENTITY_LABEL = {
  user: "Usuário",
  house: "Casa",
  reservation: "Reserva",
  blocking: "Bloqueio",
  payment: "Pagamento",
  task: "Tarefa",
  scheduler: "Automação",
};

export default function AdminAudit() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/admin/audit-logs?limit=200")
      .then((r) => { setRows(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-audit-page">
      <div className="mb-8">
        <span className="text-[11px] uppercase tracking-[0.28em] text-[#6B7280]">Rastreabilidade</span>
        <h1 className="text-3xl font-semibold text-[#0AA89C] mt-1">Log de auditoria</h1>
        <p className="text-sm text-[#22302E]/80 mt-1">
          Registro das ações administrativas relevantes: acessos, criação, alteração e cancelamento de reservas,
          alteração de valores, movimentações de pagamento e uso de mecanismos de segurança.
        </p>
      </div>

      <div className="bg-white border border-[#E4E4E7] rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F7F4EF] border-b border-[#E4E4E7]">
            <tr className="text-left">
              <Th>Data e hora</Th>
              <Th>Usuário</Th>
              <Th>Ação</Th>
              <Th>Entidade</Th>
              <Th>Referência</Th>
              <Th>Detalhes</Th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#F7F4EF]">
            {loading && (
              <tr><td colSpan={6} className="text-center py-12 text-[#6B7280]">Carregando registros...</td></tr>
            )}
            {!loading && rows.length === 0 && (
              <tr><td colSpan={6} className="text-center py-12 text-[#6B7280]">Nenhum evento registrado.</td></tr>
            )}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`audit-row-${r.id}`}>
                <Td className="whitespace-nowrap text-xs font-mono">
                  {r.created_at ? format(parseISO(r.created_at), "dd/MM/yyyy HH:mm:ss", { locale: ptBR }) : "—"}
                </Td>
                <Td>{r.user_email || "sistema"}</Td>
                <Td>{ACTION_LABEL[r.action] || r.action}</Td>
                <Td>{ENTITY_LABEL[r.entity] || r.entity}</Td>
                <Td className="font-mono text-xs text-[#6B7280]">{r.entity_id ? r.entity_id.substring(0, 8) : "—"}</Td>
                <Td className="text-xs text-[#6B7280] max-w-[280px] truncate" title={JSON.stringify(r.detail)}>
                  {r.detail && Object.keys(r.detail).length > 0 ? JSON.stringify(r.detail) : "—"}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Th({ children }) {
  return <th className="px-4 py-3 text-[10px] uppercase tracking-[0.2em] text-[#6B7280] font-semibold">{children}</th>;
}
function Td({ children, className = "", title }) {
  return <td className={`px-4 py-3 text-[#22302E] ${className}`} title={title}>{children}</td>;
}
